import { render } from "./List.vue?vue&type=template&id=49802f0e"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/TasksStatusesTypes/List.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49802f0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49802f0e', __exports__)) {
    api.reload('49802f0e', __exports__)
  }
  
  module.hot.accept("./List.vue?vue&type=template&id=49802f0e", () => {
    api.rerender('49802f0e', render)
  })

}


export default __exports__